import * as React from "react";
import {
  Dialog,
  DialogProps,
  Button,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import globalMU from "../../../../globalMU";
import { InputNumerico } from "../../inputs/InputNumerico";
import { useFormik } from "formik";

const estiloModalSimularDesconto =
  require("./modalSimularDesconto.module.scss").default;
export type Dados = {
  produto: string;
  precoLista: number;
  descontoMaximo: number;
  desconto: number;
  bonificacaoMaxima: number;
  bonificacao: number;
  precoFinal: number;

  codigoObjetoItem: number;
  comissao: number;
  identificadorOrcamento: number;
  pendenciaDescontoSobreOferta: boolean;
  percentualComissao: Number;
  percentualDescontoGeralOrcamento: number;
  percentualDescontoTotal: 0.0;
  transforming: boolean;
  userMessage: string;

  bonificacaoPendente: boolean;
  descontoPendente: boolean;
};
export type ModalSimularDescontoProps = {
  dados: Dados;

  codigoObjetoItem: number;
  comissao: number;
  identificadorOrcamento: number;
  pendenciaDescontoSobreOferta: true;
  percentualComissao: number;
  percentualDescontoGeralOrcamento: number;
  transforming: boolean;
  userMessage: string;

  procoFinalMaiorQueProduto: boolean;
  DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS: boolean;

  onAplicar: (dados: Dados) => void;
};

export const ModalSimularDesconto = (props: ModalSimularDescontoProps) => {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps["scroll"]>("paper");

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const formik = useFormik({
    initialValues: { ...props.dados },
    onSubmit: (values, {}) => {},
    enableReinitialize: true,
  });

  return (
    <>
      <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        className={estiloModalSimularDesconto.dialogModalSimularDesconto}
      >
        <div className={estiloModalSimularDesconto.titulo}>
          <h4 style={{ fontWeight: 700 }}>Simulação de Desconto</h4>
          <div>
            <a onClick={handleClose}>
              <FontAwesomeIcon
                icon={faTimes}
                className={estiloModalSimularDesconto.exit}
              />
            </a>
          </div>
        </div>
        <DialogContent
          dividers={scroll === "paper"}
          style={{ padding: " 15px" }}
        >
          <div className={estiloModalSimularDesconto.form}>
            <label>Produto</label>
            <div className={estiloModalSimularDesconto.produto}>
              {props.dados.produto}
            </div>

            <label>Preço de Lista</label>
            <div>
              {globalMU.formatarValorNumerico(props.dados.precoLista, 2, true)}
            </div>

            <label>Desconto Máximo (%)</label>
            <div>
              {globalMU.formatarValorNumerico(
                props.dados.descontoMaximo,
                2,
                false
              )}
            </div>
            <label>Desconto (%)</label>
            <div>
              <InputNumerico
                onValorModificado={(valorModificado) =>
                  formik.setFieldValue("desconto", valorModificado)
                }
                valor={props.dados.desconto}
                style={props.dados.descontoPendente ? { color: "#f00" } : {}}
              />
            </div>

            {props.DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS && (
              <>
                <label>Bonificação Máxima (%)</label>
                <div>
                  {globalMU.formatarValorNumerico(
                    props.dados.bonificacaoMaxima,
                    2,
                    true
                  )}
                </div>

                <label>Bonificação (%)</label>
                <div>
                  <InputNumerico
                    onValorModificado={(valorModificado) =>
                      formik.setFieldValue("bonificacao", valorModificado)
                    }
                    valor={props.dados.bonificacao}
                    style={
                      props.dados.bonificacaoPendente ? { color: "#f00" } : {}
                    }
                  />
                </div>
              </>
            )}

            <label>Preço Final</label>
            <div>
              <InputNumerico
                onValorModificado={(valorModificado) =>
                  formik.setFieldValue("precoFinal", valorModificado)
                }
                valor={formik.values.precoFinal}
                style={props.procoFinalMaiorQueProduto ? { color: "#f00" } : {}}
              />
            </div>
          </div>

          <DialogActions style={{ padding: "15px" }}>
            <button
              className={estiloModalSimularDesconto.botao}
              onClick={(e) => {
                !props.procoFinalMaiorQueProduto
                  ? props.onAplicar(formik.values)
                  : {};
              }}
            >
              Ok
            </button>
            <button
              className={estiloModalSimularDesconto.botao}
              onClick={handleClose}
            >
              Cancelar
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
